import { render, staticRenderFns } from "./index-header.vue?vue&type=template&id=7dd7ce1a&scoped=true&"
import script from "./index-header.vue?vue&type=script&lang=js&"
export * from "./index-header.vue?vue&type=script&lang=js&"
import style0 from "./index-header.vue?vue&type=style&index=0&id=7dd7ce1a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd7ce1a",
  null
  
)

export default component.exports